export default __webpack_public_path__ + "static/media/Boots of Bristling Ire.1f23cb9a.jpg";